// DenturesData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string;
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const dentures: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    en: {
        "url": "",
        "meta": {
            "title": "Denture Teeth Dubai",
            "description": "Get quality denture teeth at the best Dental Clinic in Dubai. Restore missing teeth with partial or implant-supported dentures for a natural, lasting smile.",
            "robots": "",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": ["Home", "Services", "Denture Teeth Dubai"],
        "hero": {
            "title": "",
            "subtitle": "",
            "description": "Get the most optimal level of comfort and confidence with our denture teeth crafted specially for you. But at Elite Body Home, we know that a healthy, stunning smile goes beyond looks. With our fully customized dentures, you can enjoy the natural look and feel of teeth and comfortably enjoy normal speaking and eating functions! Whether looking for full dentures or partial, we will walk you through the entire process until you get that perfect fit and perfect look. Our denture teeth are personalized to search and re-discover a smile and life once extra."
        },
        "howItWorks": {
            "title": "What Are Denture Teeth?",
            "description": "The denture teeth are literally artificial crowns mounted on a denture plate or base that's for sale. They resemble and function like your natural teeth, allowing you to eat, speak, and smile naturally."
        },
        "procedureSteps": {
            "heading": "Steps For Denture Procedure",
            "para": "Dentures are often delivered in different stages. Every step is important for achieving a comfortable fit and optimal function with the dentures.",
            "steps": [
                {
                    "title": "Specialist Consultations & Examinations",
                    "desc": "You will have to evaluate your oral health, dental x-rays, and discuss your needs and expectations for denture teeth with your dentist.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "Impressions of Your Mouth",
                    "desc": "A mold of your gums and any remaining teeth is created to ensure the dentures fit correctly.",
                    "icon": "fa-solid fa-teeth-open"
                },
                {
                    "title": "Creation of the Denture",
                    "desc": "With the impressions, a dental lab fabricates custom-fitted dentures molded to your mouth's contours.",
                    "icon": "fa-solid fa-teeth"
                },
                {
                    "title": "Final Denture Fitting",
                    "desc": "At that stage, the final set of dentures is adjusted to ensure they fit comfortably and look natural.",
                    "icon": "fa-solid fa-teeth"
                },
                {
                    "title": "Trial Fitting and Adjustments",
                    "desc": "A trial denture is then directed to ensure it fits properly and changes are created when necessary.",
                    "icon": "fa-solid fa-screwdriver-wrench"
                },
                {
                    "title": "Follow-Up Appointments",
                    "desc": "Your dentist may arrange follow-up appointments to ensure optimal comfort and make any necessary adjustments",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "",
            "para": "Well, there are numerous advantages of denture teeth to support your oral health as well as your body fitness. If you are one of the many Americans who are missing a few teeth or even an entire set, dentures can improve your quality of daily life.",
            "items": [
                {
                    "title": "Restored Functionality",
                    "desc": "This solves issues created from having a few single missing teeth; dentures enables you to chew and speak as normal.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Improved Appearance",
                    "desc": "They are rebuilding the architecture of your face, making you look younger.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Boosted Confidence",
                    "desc": "Dentures can restore your confidence and allow you to smile and interact with people without worrying about missing teeth.",
                    "icon": "fa-solid fa-face-grin-wide"
                },
                {
                    "title": "Custom Fit",
                    "desc": "Dentures are meant to fit well, to eliminate the possibility of irritation or sores developing on the gums.",
                    "icon": "fa-solid fa-ruler-combined"
                },
                {
                    "title": "Affordable Solution",
                    "desc": "Detracts cost– when compared to other dental restoration options, dentures are an economical option.",
                    "icon": "fa-solid fa-hand-holding-dollar"
                },
                {
                    "title": "Easier Oral Hygiene",
                    "desc": "You may find it easier to brush your teeth and gums with removable dentures.",
                    "icon": "fa-solid fa-broom"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Dentures teeth work well for many, but are not a perfect solution for everyone. While for our particular case dentures were the right call, a few things were left to weigh in before making a decision.",
            "items": [
                {
                    "title": "People with Missing Teeth",
                    "desc": "Dentures can be the preferred option when multiple or all of the teeth are lost, which is often the result of aging, injury, or decay.",
                    "icon": "fa-solid fa-tooth"
                },
                {
                    "title": "Patients with Weakened Gums",
                    "desc": "If your gums are not strong enough to support other dental restorations, such as implants, dentures are a great solution.",
                    "icon": "fa-solid fa-teeth-open"
                },
                {
                    "title": "Non-Candidates for Implants",
                    "desc": "Dentures are a good choice for patients who are not good candidates for dental implants, which more commonly happens based on bone density or medical conditions.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "For People Whose Businesses Are Not Surgical",
                    "desc": "Dentures are the right option if you want a less invasive and a more cost-effective solution for missing teeth than surgery.",
                    "icon": "fa-solid fa-scissors"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "Before being fitted for denture teeth, you should make sure to prepare correctly. This process allows for proper fitting of the dentures, giving you the best experience possible.",
            "items": [
                {
                    "title": "Oral Examination",
                    "desc": "Your dentist will perform a comprehensive evaluation of your gums and remaining teeth.",
                    "icon": "fa-solid fa-magnifying-glass"
                },
                {
                    "title": "Address Any Dental Issues",
                    "desc": "If there are any cavities, infection, or other dental health issues, they should be treated before the fitting of the denture.",
                    "icon": "fa-solid fa-teeth"
                },
                {
                    "title": "Impressions",
                    "desc": "Dentures are made to fit perfectly by taking molds or impressions of your mouth.",
                    "icon": "fa-solid fa-dental-mold"
                },
                {
                    "title": "Dietary Adjustments",
                    "desc": "In the short period immediately after you receive dentures, you may have to change your diet to soft foods until you get accustomed to wearing them.",
                    "icon": "fa-solid fa-apple-whole"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "After you've received your denture teeth, the more important thing is to take care of them appropriately so that they will last longer without your discomfort.",
            "items": [
                {
                    "title": "Natural Appearance",
                    "desc": "Modern dentures look similar to natural teeth, enhancing the appearance of your smile.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Improved Eating and Speaking",
                    "desc": "With time and practice you will learn to eat a wide range of foods as well as articulate clearly with your new dentures.",
                    "icon": "fa-solid fa-comments"
                },
                {
                    "title": "Regular Check-ups",
                    "desc": "Your dentist can assess the fit of your dentures and make adjustments as needed.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "Daily Cleaning Routine",
                    "desc": "",
                    "icon": "fa-solid fa-broom"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    question: "How long do dentures last?",
                    answer:
                        "With proper care, dentures can last anywhere from 5 to 10 years, though adjustments may be needed over time.",
                },
                {
                    question: "Can I sleep with my dentures in?",
                    answer:
                        "While it is possible, it’s generally recommended to remove them at night to allow your gums to rest.",
                },
                {
                    question: "How do I clean my dentures?",
                    answer:
                        "Clean your dentures daily using a soft-bristle toothbrush and denture cleaner. Avoid using regular toothpaste, as it can be too abrasive.",
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    ar: {
        "url": "",
        "meta": {
            "title": "أطقم الأسنان في دبي",
            "description": "احصل على أعلى درجات الراحة والثقة مع أطقم الأسنان المصممة خصيصًا لك من ايليت بودي هوم. ندرك أن الابتسامة الصحية والجذابة لا تتعلق بالمظهر فقط، بل تتعلق أيضًا بالراحة وجودة الحياة. بفضل أطقم الأسنان المصممة بالكامل حسب حالتك، ستحصل على مظهر طبيعي وشعور بالراحة مع أسنانك، ما يتيح لك الاستمتاع بالأكل والتحدث بكل ثقة وسهولة. سواء كنت بحاجة إلى طقم أسنان متحرك كامل أو جزئي، سنرافقك خطوة بخطوة حتى تحصل على المقاس المثالي والمظهر الذي يليق بك. تُصنع أطقم الأسنان لدينا بشكل شخصي لتمنحك ابتسامة جديدة تعيد لك ثقتك بنفسك وحيويتك.",
            "robots": "",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "أطقم الأسنان في دبي"],
        "hero": {
            "title": "استعد ثقتك بنفسك مع أطقم أسنان مصممة خصيصًا لتناسبك بكل دقة",
            "subtitle": "",
            "description": "احصل على أعلى درجات الراحة والثقة مع أطقم الأسنان المصممة خصيصًا لك من ايليت بودي هوم. ندرك أن الابتسامة الصحية والجذابة لا تتعلق بالمظهر فقط، بل تتعلق أيضًا بالراحة وجودة الحياة. بفضل أطقم الأسنان المصممة بالكامل حسب حالتك، ستحصل على مظهر طبيعي وشعور بالراحة مع أسنانك، ما يتيح لك الاستمتاع بالأكل والتحدث بكل ثقة وسهولة. سواء كنت بحاجة إلى طقم أسنان متحرك كامل أو جزئي، سنرافقك خطوة بخطوة حتى تحصل على المقاس المثالي والمظهر الذي يليق بك. تُصنع أطقم الأسنان لدينا بشكل شخصي لتمنحك ابتسامة جديدة تعيد لك ثقتك بنفسك وحيويتك."
        },
        "howItWorks": {
            "title": "ما هي أطقم الأسنان؟",
            "description": "أطقم الأسنان هي تيجان صناعية مُثبتة على قاعدة مخصصة، كما إنها واحدة من تركيبات الأسنان، وتُستخدم لتعويض الأسنان المفقودة والفراغات. تُصمم لتشبه الأسنان الطبيعية من حيث الشكل والوظيفة، مما يسمح لك بالأكل والكلام والابتسام براحة تامة."
        },
        "procedureSteps": {
            "heading": "خطوات تركيب طقم الأسنان",
            "para": "يتم تسليم أطقم الأسنان عادة على مراحل متعددة، حيث تُعد كل مرحلة ضرورية للحصول على أطقم مريحة ووظيفة مثالية.",
            "steps": [
                {
                    "title": "الاستشارات والفحوصات المتخصصة",
                    "desc": "يُجري الطبيب تقييمًا شاملًا لصحة الفم، وقد يقوم بالتقاط صور أشعة سينية للأسنان، كما يناقش معك احتياجاتك وتوقعاتك من طقم الأسنان.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "أخذ طبعات للفم",
                    "desc": "تؤخذ طبعة دقيقة للثة وأي أسنان متبقية، لضمان أن الطقم سيُصمم بشكل يتناسب تمامًا مع فمك.",
                    "icon": "fa-solid fa-teeth-open"
                },
                {
                    "title": "تصنيع طقم الأسنان",
                    "desc": "تُرسل الطبعات إلى المختبر لصنع طقم أسنان مخصص يتوافق مع شكل وتضاريس فمك بدقة.",
                    "icon": "fa-solid fa-teeth"
                },
                {
                    "title": "تجربة الطقم وإجراء التعديلات",
                    "desc": "يتم تركيب طقم تجريبي أولًا لتجربته والتأكد من ملاءمته، وتُجرى بعض التعديلات إذا لزم الأمر.",
                    "icon": "fa-solid fa-screwdriver-wrench"
                },
                {
                    "title": "التركيب النهائي لطقم الأسنان",
                    "desc": "يُركب الطقم النهائي بعد التأكد من أنه مريح وذو مظهر طبيعي.",
                    "icon": "fa-solid fa-teeth"
                },
                {
                    "title": "زيارات المتابعة",
                    "desc": "قد يحدد الطبيب مواعيد متابعة للتأكد من أن الطقم مستقر ومريح، وإجراء أي تعديلات إضافية إذا احتاج الأمر.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "الفوائد",
            "subheading": "",
            "para": "لا تقتصر فوائد أطقم الأسنان على دعم صحة الفم فقط، بل تمتد أيضًا لتحسين جودة الحياة بشكل عام، خاصةً لمن يعانون من فقدان بعض الأسنان أو جميعها.",
            "items": [
                {
                    "title": "استعادة وظائف الفم",
                    "desc": "يساعد طقم الأسنان في حل مشكلات المضغ والكلام الناتجة عن فقدان الأسنان، مما يُعيد لك القدرة على تناول الطعام والتحدث.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "تحسين المظهر العام",
                    "desc": "يعيد بناء الشكل الطبيعي للفك والوجه، مما يمنحك مظهرًا أكثر شبابًا وحيوية.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "يساهم طقم الأسنان في استعادة الابتسامة والثقة أثناء التعامل مع الآخرين دون القلق من مظهر الفم أو فقدان الأسنان.",
                    "icon": "fa-solid fa-face-grin-wide"
                },
                {
                    "title": "تصميم مخصص",
                    "desc": "يُصمم طقم الأسنان خصيصًا ليناسب شكل فمك، مما يقلل من فرص حدوث التهابات أو تقرحات ناتجة عن الاحتكاك.",
                    "icon": "fa-solid fa-ruler-combined"
                },
                {
                    "title": "خيار اقتصادي",
                    "desc": "تُعتبر أطقم الأسنان من أكثر خيارات تعويض الأسنان توفيراً من حيث التكلفة، مقارنةً بزراعة الأسنان أو التركيبات الثابتة.",
                    "icon": "fa-solid fa-hand-holding-dollar"
                },
                {
                    "title": "سهولة في العناية والنظافة",
                    "desc": "تُسهل أطقم الأسنان القابلة للإزالة تنظيف الأسنان واللثة.",
                    "icon": "fa-solid fa-broom"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "رغم أن طقم الأسنان يُعد خيارًا مناسبًا للكثير من الأشخاص، إلا أنه ليس الحل المثالي للجميع. يجب النظر في بعض العوامل قبل اتخاذ القرار بتركيبه، وذلك لضمان تحقيق أفضل نتيجة ممكنة.",
            "items": [
                {
                    "title": "الأشخاص الذين فقدوا عدة أسنان",
                    "desc": "يُعد طقم الأسنان خيارًا شائعًا في حالات فقدان عدة أسنان أو فقدان الأسنان بالكامل، سواء كان ذلك بسبب التقدم في العمر أو الإصابة أو تسوس الأسنان.",
                    "icon": "fa-solid fa-tooth"
                },
                {
                    "title": "المرضى الذين يعانون من ضعف في اللثة",
                    "desc": "يكون طقم الأسنان هو الحل الأمثل عندما لا تكون اللثة قوية بما يكفي لدعم التركيبات الثابتة مثل زراعة الأسنان.",
                    "icon": "fa-solid fa-teeth-open"
                },
                {
                    "title": "الأشخاص غير المؤهلين لزراعة الأسنان",
                    "desc": "يعتبر طقم الأسنان هو الخيار الأفضل لمن لا تسمح لهم كثافة عظام الفك أو ظروفهم الصحية بالإجراء زراعة الأسنان.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "الأشخاص الذين يبحثون عن حلول غير جراحية",
                    "desc": "يُعتبر طقم الأسنان خيارًا أقل تدخلاً جراحيًا وأكثر توفيرًا من الناحية المالية مقارنةً بالبدائل الجراحية.",
                    "icon": "fa-solid fa-scissors"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يجب الالتزام بخطوات تحضيرية قبل البدء بتركيب طقم الأسنان، لتضمن الحصول على أفضل ملاءمة ممكنة للطقم، وتوفير تجربة مريحة ونتائج فعالة على المدى الطويل.",
            "items": [
                {
                    "title": "فحص شامل للفم",
                    "desc": "سيقوم طبيب الأسنان بإجراء تقييم دقيق وشامل للثة والأسنان المتبقية.",
                    "icon": "fa-solid fa-magnifying-glass"
                },
                {
                    "title": "معالجة أي مشكلات صحية",
                    "desc": "يجب معالجة أي تسوس أو التهابات أو أمراض فموية أخرى قبل الشروع في تركيب طقم الأسنان.",
                    "icon": "fa-solid fa-teeth"
                },
                {
                    "title": "أخذ طبعات دقيقة للفم",
                    "desc": "يتم أخذ طبعات أو قوالب دقيقة لفمك من أجل تصميم طقم أسنان يتناسب تمامًا مع شكل فكك.",
                    "icon": "fa-solid fa-dental-mold"
                },
                {
                    "title": "التعديلات الغذائية المؤقتة",
                    "desc": "قد تحتاج إلى تناول أطعمة لينة في الأيام الأولى بعد تركيب الطقم، لتسهيل التأقلم مع الطقم الجديد وتجنب الضغط الزائد على اللثة.",
                    "icon": "fa-solid fa-apple-whole"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "بعد استلامك لطقم الأسنان، تصبح العناية اليومية هي العامل الأهم لضمان راحة تدوم طويلًا دون أي انزعاج.",
            "items": [
                {
                    "title": "المظهر الطبيعي",
                    "desc": "تتميز أطقم الأسنان الحديثة بمظهر يشبه الأسنان الطبيعية، مما يُحسن من مظهر ابتسامتك.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "تحسن في الأكل والنطق",
                    "desc": "ستتمكن من تناول مجموعة متنوعة من الأطعمة بسهولة أكبر بمرور الوقت وبالممارسة، بجانب تحسن وضوح النطق والتحدث بطلاقة.",
                    "icon": "fa-solid fa-comments"
                },
                {
                    "title": "فحوصات دورية",
                    "desc": "يجب زيارة طبيب الأسنان بشكل منتظم لفحص ملاءمة الطقم، وإجراء التعديلات الضرورية.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "روتين تنظيف يومي",
                    "desc": "يجب تنظيف طقم الأسنان يومياً باستخدام فرشاة ومنتجات مخصصة للحفاظ على نظافة الطقم.",
                    "icon": "fa-solid fa-broom"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "",
            "subheading": "",
            "items": []
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    shared: {
        images: {
            main: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Ityujymage-8-scaled.jpg",
            beforeAfter: [],
            introductionImage: "",
        },
        product: {
            id: 15,
            title: "Dental Implants",
            price: 699,
            description: "Dental implants are a modern and scientifically approved method for replacing missing teeth. Unlike traditional dentures or bridges, which rest on the gums, implants are implanted into the jawbone just like natural teeth."
        }
    }
};
